import { combineEpics, createEpicMiddleware } from "redux-observable";
import { captchaEpics } from "./captcha/epics";
import { legalRepresentativePopupEpics } from "./legal-representative-popup/epics";
import { pageEpics } from "./page/epics";
import { preQuotationEpics } from "./pre-quotation/epics";
import { quotationPaymentpEpics } from "./quotation-payment/epics";
import { quotationPopupEpics } from "./quotation-popup/epics";
import { quotationEpics } from "./quotation/epics";
import { payrollFileEpics } from "./payroll-file/epics";
import { emissionEpics } from "./emission/epics";
import { zohoEpics } from "./zoho/epics";

export const rootEpic = combineEpics(
    quotationPopupEpics,
    captchaEpics,
    pageEpics,
    legalRepresentativePopupEpics,
    quotationEpics,
    preQuotationEpics,
    quotationPaymentpEpics,
    payrollFileEpics,
    emissionEpics,
    zohoEpics
);

export default createEpicMiddleware();
